import { Link } from "react-router-dom";
import React, { Component } from "react";
import logo from "../../assets/img/brand-logo/burgeon-logo.png";

class Logo extends Component {
  render() {
    return (
      <div className="logo-area">
        <Link to="/">
          <img src={logo} alt="Logo" style={{ width: "100px", height: "auto" }} />
        </Link>
      </div>
    );
  }
}

export default Logo;